import React from "react";
import axios from "axios";

import URL, { headers } from "../../common/variables";
import { clearToken, saveToken } from "./../../common/functions";

import "./Login.scss";

export default class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      pass: "",
      isError: false,
      isErrorMessage: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleError = this.handleError.bind(this);
    this.showErrors = this.showErrors.bind(this);
    this.focusInput = this.focusInput.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    const { email: username, pass: password } = this.state;
    let havingErrors = false;

    if (username === "") {
      havingErrors = true;
      this.setState((prevState) => ({
        isError: true,
        isErrorMessage: [
          ...prevState.isErrorMessage,
          "Es necesario que venga tu correo o usuario",
        ],
      }));
    }

    if (password === "") {
      havingErrors = true;
      this.setState((prevState) => ({
        isError: true,
        isErrorMessage: [
          ...prevState.isErrorMessage,
          "La contraseña no puede venir vacía",
        ],
      }));
    }

    if (!havingErrors) {
      const { email: username, pass: password } = this.state;
      const data = { username, password };
      const endpoint = `${URL}/rest-auth/login/`;

      clearToken();

      axios
        .post(endpoint, data, { headers })
        .then((response) => {
          const { key } = response.data;

          saveToken(key);

          location.reload();
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.handleError(`404 endpoint not found at ${endpoint}`);
          } else if (error.response) {
            const obj = error.response.data;

            this.handleError(obj.non_field_errors.join());
          }
        });
    }
  }

  handleError(message) {
    this.setState({ isError: true, isErrorMessage: [message] });
  }

  showErrors() {
    const { isErrorMessage } = this.state;

    return isErrorMessage.map((txt, pos) => <div key={pos}>{txt}</div>);
  }

  focusInput() {
    const { isError } = this.state;

    if (isError) {
      this.setState({ isError: false, isErrorMessage: [] });
    }
  }

  render() {
    const { isError } = this.state;

    return (
      <div className="login">
        <h2 className="titled-box box-title text-white">Iniciar Sesión</h2>
        <form onSubmit={this.handleSubmit}>
          <input
            type="text"
            value={this.state.email}
            onChange={(e) => this.setState({ email: e.target.value })}
            placeholder="Usuario*"
            className="form-control rounded-0"
            onFocus={this.focusInput}
          />

          <input
            type="password"
            value={this.state.pass}
            onChange={(e) => this.setState({ pass: e.target.value })}
            placeholder="Contraseña*"
            className="form-control rounded-0 mt-4"
            onFocus={this.focusInput}
          />

          {this.props.btnPasswordReset}

          {isError && (
            <div className="mt-1 mb-4 text-danger">
              <div className="text-center">
                <small>{this.showErrors()}</small>
              </div>
            </div>
          )}

          <button
            type="submit"
            className="btn btn-lg btn-block bg-warning mt-4 mb-2"
          >
            Ingresar
          </button>

          <p className="text-center">
            <small>
              <sup>*</sup>Estos campos son obligatorios
            </small>
          </p>
        </form>
      </div>
    );
  }
}
